import { Button, Col, Empty, message, Row, Spin, Table, Tabs, Tooltip, Tree } from 'antd'
import styles from './index.module.less'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import {
  getAllSapce,
  quoteBudgetItemTree,
  quoteBudgetSelectQuoteBudgetInfo,
  getListBudgetDtl as getListBudgetDtlByType,
  getQuoteGoodsList,
  subSearchList,
} from '@/services/order'
import { getListBudgetDtl } from '@/services/goodsFrontendTenant'

import { isArray, isBoolean } from 'lodash-es'
import { SBack } from 'shj-components'
import tagsMap from '../../quoteSelection/utils'
import { treeToOneArr } from '@/common/utils'
import dayjs from 'dayjs'
import { replaceRule } from '@/utils/data'
import exportIcon from '@/assets/export-icon.png'
import { fileDownload } from '@/utils/download'
import UrlConfig from '@/api/UrlConfigs'
import { render } from 'react-dom'
export default function PreviewList() {
  const { budgetId } = useParams() // 报价id
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const orderId = searchParams.get('orderId')
  const [tabsList, setTabsList] = useState<any>([])
  const [activeKey, setActiveKey] = useState<any>('CHOOSE')
  const [spaceList, setSpaceList] = useState<any>([])
  const [spaceOneArray, setSpaceOneArray] = useState<any>([])
  const [selectedKeys, setSelectedKeys] = useState<any>([])
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([])
  const [autoExpandParent, setAutoExpandParent] = useState(true)
  const [spaceId, setSpaceId] = useState<any>(undefined) // 当前空间id
  const [params, setParams] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [dataSource, setDataSource] = useState<any>([])
  const [quoteBudgetInfo, setQuoteBudgetInfo] = useState<any>({})
  const [orderInfo, setOrderInfo] = useState<any>({})
  const [argObj, setArgObj] = useState<any>({
    roomNum: 0, //卧室个数
    toiletNum: 0, //卫生间个数
    area: 0, //报价面积
  })
  const orderState = searchParams.get('orderState')
  const tableRef = useRef<any>(null)
  useEffect(() => {
    getTabsList()
    getOptionList()
    getTopData()
    getOrderInfo()
  }, [])
  const tableTitleRef = useRef<any>(null)

  const getOrderInfo = async () => {
    const data: any = await getQuoteGoodsList({
      data: {
        orderId: orderId,
        queryExpectProjectStartDate: true,
      },
    })
    if (data && data?.length > 0) {
      setOrderInfo(data[0])
    }
  }
  const getTabsList = async () => {
    const res: any = await quoteBudgetItemTree({
      params: {
        quoteBudgetId: budgetId,
      },
    })
    console.log(res, 'res')
    if (isArray(res)) {
      console.log(res, 'res')
      if (!res?.find(item => item?.label === '选材')) {
        res?.unshift({
          label: '选材',
          object: {
            code: 'CHOOSE',
            summaryAmount: 0,
          },
        })
      }
      setTabsList([
        ...res.map((item: any) => {
          if (item?.label === '选材') {
            item.label = '全部选材'
          }
          if (item?.label === '优惠活动') {
            item.label = '活动'
          }
          return {
            ...(item || {}),
            label:
              item?.label +
              (item?.object?.summaryAmount ? `（￥${String(item?.object?.summaryAmount)}）` : ''),
            key: item?.object?.code,
          }
        }),
      ])
    }
  }
  const getTopData = (handle?: any) => {
    // setLoading(true)
    quoteBudgetSelectQuoteBudgetInfo({
      params: {
        quoteBudgetId: budgetId,
      },
    })
      .then((res: any) => {
        if (res?.skuArgJson) {
          let roomNum = 0
          let toiletNum = 0
          let area = 0
          let skuArgList = JSON.parse(res?.skuArgJson || '[]')
          skuArgList.forEach((arg: any) => {
            if (arg.argCode === 'BED_ROOM' && arg.argVal) {
              roomNum = Number(arg.argVal)
            }
            if (arg.argCode === 'toilet_num' && arg.argVal) {
              toiletNum = Number(arg.argVal)
            }
            if (arg.argCode === 'BUDGET_AREA' && arg.argVal) {
              area = Number(arg.argVal)
            }
          })
          setArgObj({ roomNum, toiletNum, area })
        }
        setQuoteBudgetInfo(res || {})
      })
      .finally(() => {
        // setLoading(false)
      })
  }
  const getOptionList = async () => {
    let resList: any = await getAllSapce(budgetId)
    if (resList && resList?.length) {
      resList = changeTreefied(resList)
      handleTree(resList)
      setSpaceList(resList)
    }
  }
  const handleTree = array => {
    let oneArray = treeToOneArr(array)
    if (array && array?.length) {
      let expandedKeys: any = [] // 处理默认全部展开
      oneArray?.forEach((item: any) => {
        if (item?.children && item?.children?.length) {
          expandedKeys.push(item?.id)
        }
      })
      setSelectedKeys([oneArray[0]?.id])
      setSpaceId(oneArray[0]?.id)
      setExpandedKeys(expandedKeys)
    }
    console.log(oneArray, 'oneArray')

    setSpaceOneArray(oneArray)
  }
  const changeTreefied = (data: any) => {
    data.forEach((item: any) => {
      item.title = item?.object?.showName
      item.key = item?.id
      if (item.children?.length) {
        item.children = changeTreefied(item.children)
        item.selectable = false
      }
    })
    return data
  }
  const onChange = (key: string) => {
    console.log(key, 'key')
    console.log(tabsList)
    if (key !== 'CHOOSE') {
      setLoading(true)
      let refItemId = tabsList?.find((item: any) => item?.key === key)?.object?.id
      if (key === 'SUB') {
        subSearchList({
          data: {
            quoteBudgetId: budgetId,
            refItemId: refItemId,
            sortByItem: true,
          },
        })
          .then((res: any) => {
            if (res && res.length) {
              res = handleData(res, key)
            }
            setDataSource(res || [])
          })
          .finally(() => {
            setLoading(false)
          })
      } else {
        getListBudgetDtlByType({
          id: budgetId,
          params: {
            refItemId: refItemId,
            sortByItem: true,
          },
        })
          .then((res: any) => {
            if (res && res.length) {
              res = handleData(res)
            }
            setDataSource(res || [])
          })
          .finally(() => {
            setLoading(false)
          })
      }
    } else {
      fetchList()
    }
    setActiveKey(key)
  }
  const handleData = (data, type?) => {
    let newData: any = []
    data.forEach((item: any, index) => {
      if (item?.budgetDtlVoList?.length > 1) {
        item?.budgetDtlVoList?.forEach((el: any) => {
          let newItem: any = { ...item }
          newItem.budgetDtlVoList = [el]
          newData.push(newItem)
        })
      } else {
        newData.push(item)
      }
    })

    if (type === 'SUB') {
      newData = newData.map((item: any, index) => {
        return {
          ...item,
          budgetDtlVoList: [{ ...item }],
        }
      })
      console.log(newData)
    }
    newData = newData.map((item: any, index) => {
      return {
        ...item,
        orderSeq: index + 1,
        key: index + 1,
      }
    })
    return newData
  }
  const goBack = () => {
    // history.back()
    navigate(
      `/order/list/details/quote-space-selection/${budgetId}?orderState=${orderState}&orderId=${orderId}&activeKey=${'chooseMaterial'}`
    )
  }
  const onExpand = (newExpandedKeys: React.Key[]) => {
    setExpandedKeys(newExpandedKeys)
    setAutoExpandParent(false)
  }
  const onSelect = (selectedKeys, info) => {
    if (selectedKeys && selectedKeys.length) {
      let param = { ...params }
      param.spaceId = selectedKeys[0]
      setParams({ ...param })
      setSpaceId(selectedKeys[0])
      // fetchList(param)

      console.log(selectedKeys[0])
      const element: any = document.getElementById(`spaceId_${selectedKeys[0]}`)
      element.scrollIntoView({ behavior: 'smooth' })
      setSelectedKeys(selectedKeys)
    }
  }
  const titleRender = (nodeData: any) => {
    const { title } = nodeData
    const typeObj: any = {}
    // dataSource?.forEach((item: any) => {
    if (nodeData?.object?.chooseTypeEnums?.length) {
      nodeData?.object?.chooseTypeEnums?.forEach((el: any) => {
        if (['ADD', 'SUB', 'UP_DOWN', 'ACTIVITY'].includes(el)) {
          typeObj[el] = tagsMap[el]?.name
        }
      })
    }
    let nameStr = Object?.values(typeObj)?.join('、')
    // let errorFlag = errorObj?.itemList?.some((el: any) => el?.id === nodeData?.id)

    return (
      <div
        className={`${styles.treeTitle}  ${nodeData?.children?.length ? 'hasChildren-node' : 'child-node'} `}
        title=""
      >
        <Tooltip title={`${`${title}`}`} placement="topLeft" arrow={false}>
          <span className={styles.text}>{title}</span>
        </Tooltip>
      </div>
    )
  }
  useEffect(() => {
    fetchList()
    // spaceId && getBtnList()
  }, [])
  const fetchList = async (param?: any) => {
    setLoading(true)
    let resData: any
    try {
      resData = await getListBudgetDtl({
        data: {
          budgetId: budgetId,
          // spaceId: param?.spaceId ? param?.spaceId : spaceId,
          skuSourceType: null,
        },
      })
      resData = resData.map((item: any, index) => {
        return {
          ...item,
          orderSeq: index + 1,
          key: index + 1,
        }
      })
      // dataHanlde(resData)
      setDataSource(resData)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }
  const columns: any = [
    {
      title: '序号',
      dataIndex: 'orderSeq',
      width: 60,
      render: (text: any, record: any, index) => {
        return index + 1
      },
    },
    {
      title: '所在位置',
      dataIndex: 'spaceName',
      width: 120,
      ellipsis: true,
      hidden: activeKey === 'CHOOSE',
      render: (text: any, record: any) => renderListFn(record, 'spaceName'),
    },
    {
      title: '项目类型',
      dataIndex: 'typeNameList',
      width: 120,
      render: (text: any, record: any) => {
        if (record?.budgetDtlVoList?.length > 0) {
          return renderListFn(record, 'typeNameList')
        } else {
          return (
            text &&
            text?.map((str: string) => (
              <span
                key={str}
                className={'normal_tag_style'}
                style={{
                  color: tagsMap[str]?.color,
                  backgroundColor: tagsMap[str]?.bgColor,
                  marginRight: '8px',
                }}
              >
                {tagsMap[str]?.name}
              </span>
            ))
          )
        }
      },
      filters: [
        { text: '通项', value: 'GENERAL' },
        { text: '标配', value: 'STANDARD' },
        { text: '非标配', value: 'NOTSTANDARD' },
        { text: '增项', value: 'ADD' },
        { text: '减项', value: 'SUB' },
        { text: '升降级', value: 'UP_DOWN' },
        { text: '活动', value: 'ACTIVITY' },
        { text: '项目', value: 'PROJECT' },
      ],
      filterSearch: true,
      onFilter: (value, record) => {
        return record.typeNameList?.includes(value)
      },
      hidden: activeKey !== 'CHOOSE',
    },
    { title: '商品类型', dataIndex: 'name', width: 120, ellipsis: true },
    {
      title: '商品',
      width: 400,
      dataIndex: 'pproduct',
      render: (text: any, record: any) => {
        // 判断是否通项  通项budgetDtlVoList 为空是正常的 表示可以选材 其他类型 为空才取generalBudgetDtlVo
        let list
        if (record?.typeNameList?.includes('GENERAL') && record?.typeNameList?.length === 1) {
          list = record?.budgetDtlVoList
        } else {
          list =
            (record?.budgetDtlVoList?.length
              ? record?.budgetDtlVoList
              : [record?.generalBudgetDtlVo]) || []
        }
        if (isArray(list) && !!list?.length) {
          return list.map((item, index) => {
            return (
              // 有产品都只有这一种显示方式
              <div className={styles.productItemBox}>
                {showTagsTag(item)}
                {showNationalTagRender(item, 'list')}
                {/* <Popover
                  overlayClassName={styles.Sku_popover}
                  className="skuName_box"
                  content={() => SkuRender(item)}
                  arrow={false}
                  placement="bottomLeft"
                > */}
                <Tooltip
                  placement="topLeft"
                  arrow={false}
                  title={
                    record?.typeNameList?.includes('GENERAL') && record?.typeNameList?.length === 1
                      ? null
                      : item.name
                  }
                >
                  {record?.typeNameList?.includes('GENERAL') &&
                  record?.typeNameList?.length === 1 ? null : (
                    <span>{item.name}</span>
                  )}
                </Tooltip>
                {/* </Popover> */}
              </div>
            )
          })
        }
      },
    },
    {
      title: '规格',
      width: 210,
      dataIndex: 'dynaOptions',
      ellipsis: true,
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 75,
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 100,
      align: 'right',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '预算量计算式',
      width: 120,
      dataIndex: 'displayQtyFormular',
      render: (text: any, record: any) => renderListFn(record, 'displayQtyFormular'),
    },
    {
      title: '预算量',
      dataIndex: 'displayQtyValue',
      width: 100,
      align: 'right',
      render: (text: any, record: any) => renderListFn(record, 'displayQtyValue'),
    },
    {
      title: '预算合计',
      width: 120,
      dataIndex: 'budgetAmount',
      align: 'right',
      render: (text: any, record: any) => renderListFn(record, 'budgetAmount'),
    },
    {
      title: '选择日期',
      width: 150,
      dataIndex: 'createdTime',
      render: (text: any, record: any) => renderListFn(record, 'createdTime', undefined, 'date'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 150,
      ellipsis: true,
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
  ]
  const showNationalTagRender = (item: any, type?) => {
    if (type === 'list') {
      if (item?.showTags && isArray(item?.showTags)) {
        return item?.showTags?.map((tag: any) => {
          return (
            <Tooltip title={tag.tagName} arrow={false}>
              <span
                className={'normal_tag_style'}
                style={{
                  color: tagsMap.NATIONAL_UPPLEMENT?.color,
                  backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
                  marginRight: '8px',
                }}
              >
                {tag.tagName}
              </span>
            </Tooltip>
          )
        })
      } else {
        return <></>
      }
    } else {
      // 显示国补
      if (item.packDtlList?.length > 0) {
        // 组合产品需判断除了施工项外是否全是国补 判断是否除了施工项都是国补 是则显示 国补标签
        let proList = item.packDtlList
          ?.filter(item => item?.product?.sourceType !== 'CONSTRUCTION')
          ?.filter(item => item.required || (!item.required && item.checked))
        let allNational = false
        if (proList?.length) {
          allNational = proList?.every((item: any) => {
            if (item.selectSkuId) {
              return item?.skuList?.find((sku: any) => sku.id === item.selectSkuId)?.showTags
            }
            return false
          })
          if (allNational) {
            return (
              <Tooltip title={tagsMap.NATIONAL_UPPLEMENT.name} arrow={false}>
                <span
                  className={'normal_tag_style'}
                  style={{
                    color: tagsMap.NATIONAL_UPPLEMENT?.color,
                    backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
                    marginRight: '8px',
                  }}
                >
                  {tagsMap.NATIONAL_UPPLEMENT.name}
                </span>
              </Tooltip>
            )
          }
        }
      } else {
        let showTags = item?.productSpu?.skuList?.find(
          (sku: any) => sku.id === item.productSkuId
        )?.showTags
        if (showTags && isArray(showTags)) {
          return showTags?.map((tag: any) => {
            return (
              <Tooltip title={tag.tagName} arrow={false}>
                <span
                  className={'normal_tag_style'}
                  style={{
                    color: tagsMap.NATIONAL_UPPLEMENT?.color,
                    backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
                    marginRight: '8px',
                  }}
                >
                  {tag.tagName}
                </span>
              </Tooltip>
            )
          })
        } else {
          return <></>
        }
      }
    }
  }
  const showTagsTag = item => {
    // 显示组合
    if (item?.packDtlList && item?.packDtlList.length) {
      return (
        <span
          className={'normal_tag_style'}
          style={{
            color: tagsMap.GROUP?.color,
            backgroundColor: tagsMap.GROUP?.bgColor,
            marginRight: '8px',
          }}
        >
          {tagsMap.GROUP.name}
        </span>
      )
    }
    // 显示缺货
    if (item?.stockoutMessage) {
      return (
        <span
          className={'normal_tag_style'}
          style={{
            color: tagsMap.DISABLE?.color,
            backgroundColor: tagsMap.DISABLE?.bgColor,
            marginRight: '8px',
          }}
        >
          <Tooltip title={item?.stockoutMessage} arrow={false}>
            {item?.stockoutMessage}
          </Tooltip>
        </span>
      )
    }
  }
  const renderListFn = (record: any, dataIndex: string, nodeRenderFn?: any, itemType?: any) => {
    let list
    if (record?.typeNameList?.includes('GENERAL') && record?.typeNameList?.length === 1) {
      list = record?.budgetDtlVoList
    } else {
      list =
        (record?.budgetDtlVoList?.length
          ? record?.budgetDtlVoList
          : [record?.generalBudgetDtlVo]) || []
    }

    return !!list?.length ? (
      <div>
        {list.map((item, index) => {
          let text: any = item?.[dataIndex]
          let midifyFlag =
            item.refType !== 'SUB' &&
            !item.refDeductId &&
            !item.templateFlag &&
            item.chooseFormatFlag
          let packDtlFlag =
            item.refType !== 'SUB' &&
            !item.refDeductId &&
            item.packDtlList &&
            !!item.packDtlList.length
          let skuDynamicFlag =
            item.refType !== 'SUB' &&
            !item.refDeductId &&
            item.skuDynamicVoList &&
            !!item.skuDynamicVoList.length
          if (!!text && itemType == 'dateTime') {
            text = dayjs(text).format('YYYY-MM-DD HH:mm:ss')
          }
          if (!!text && itemType == 'date') {
            text = dayjs(text).format('YYYY-MM-DD')
          }
          if (dataIndex.includes('Flag')) {
            if (isBoolean(text)) {
              text = text ? '是' : '否'
            }
            text = text == '1' ? '是' : text == '0' ? '否' : text
          }
          if (dataIndex === 'dynaOptions') {
            const strings: string[] = []
            if (
              (text && Object.keys(text).length) ||
              item?.materialDynaOptions?.length ||
              item?.packDtlList?.length
            ) {
              if (item?.materialDynaOptions?.length) {
                item?.materialDynaOptions?.forEach((el: any) => {
                  strings.push(`${el.name}：${el.optionName}`)
                })
              }
              for (let key in text) {
                strings.push(`${text[key].argName}：${text[key].valueName}`)
              }
              return (
                <div className={styles.edit_box}>
                  <Tooltip
                    title={
                      <div className={styles.edit_box_text}>
                        {strings.map((str: string) => (
                          <span>{str}</span>
                        ))}
                      </div>
                    }
                    placement="topLeft"
                    arrow={false}
                  >
                    <div className={styles.edit_box_text}>
                      {strings.map((str: string) => (
                        <span>{str}</span>
                      ))}
                    </div>
                  </Tooltip>
                </div>
              )
            } else {
              text = <span></span>
            }
          }
          if (dataIndex === 'displayQtyFormular') {
            return (
              <div className={styles.edit_box}>
                <div className={styles.edit_box_text}>{(text = replaceRule(text || ''))}</div>
              </div>
            )
          }
          if (dataIndex === 'typeNameList') {
            text = text?.map((str: string) => (
              <span
                key={str}
                className={'normal_tag_style'}
                style={{
                  color: tagsMap[str]?.color,
                  backgroundColor: tagsMap[str]?.bgColor,
                  marginRight: '8px',
                }}
              >
                {tagsMap[str]?.name}
              </span>
            ))
          }
          return (
            <Tooltip title={dataIndex !== 'typeNameList' && text} placement="topLeft" arrow={false}>
              <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                {text}
              </div>
            </Tooltip>
          )
        })}
      </div>
    ) : (
      <div>{record[dataIndex]}</div>
    )
  }
  const clickToExport = () => {
    setBtnLoading(true)
    fileDownload(UrlConfig.PlusTradeWeb.ExportCheckList + `?budgetId=${budgetId}`, {
      method: 'POST',
    })
      .then(() => {
        // setBtnLoading(false)
        setBtnLoading(false)
        message.success('导出成功')
      })
      .catch(() => {
        message.error('导出失败')
        setBtnLoading(false)
      })
  }
  // 处理数据的函数
  const processDataSource = (dataSource, spaceOneArray) => {
    if (!dataSource || !spaceOneArray) return {}

    // 创建一个对象来存储结果，key是spaceId，value是匹配的数据数组
    const result = {}

    // 遍历spaceOneArray中的每个id
    spaceOneArray.forEach(spaceItem => {
      if (!spaceItem?.children?.length) {
        const targetId = spaceItem.id

        // 在dataSource中查找匹配的数据
        const matchedRecords = dataSource.filter(record => {
          // 获取spaceId
          const spaceId = record?.spaceId
          // 检查spaceId是否等于目标id
          return spaceId === targetId
        })

        // 将匹配的数据存入结果对象
        result[targetId] = matchedRecords
      }
    })
    console.log(result, 'result')

    return result
  }
  const tableData = useMemo(() => {
    return processDataSource(dataSource, spaceOneArray)
  }, [dataSource])

  return (
    <SBack title={'选材清单'} level={3} goPath={goBack} gutter={0}>
      <div className={styles.previewListContainer}>
        <Spin spinning={loading}>
          <div className={styles.top_info_box}>
            <div className={styles.title_box}>
              <div
                className={'normal_tag_style'}
                style={{
                  color: tagsMap['BUDGETTYPE']?.color,
                  backgroundColor: tagsMap['BUDGETTYPE']?.bgColor,
                  marginRight: '8px',
                }}
              >
                {quoteBudgetInfo?.typeDisplay}
              </div>
              <p className={styles.title}>{quoteBudgetInfo?.quoteGoodsName}选材清单</p>
              <p className={styles.exportIcon} onClick={clickToExport}>
                <img src={exportIcon} alt="" />
                导出
                <Spin spinning={btnLoading} size="small" style={{ marginLeft: '4px' }} />
              </p>
            </div>
            <div className={styles.base_info_box}>
              <Row style={{ marginBottom: '16px' }}>
                <Col span={8}>
                  客户姓名:
                  <span className={styles.show_title}> {quoteBudgetInfo?.customerName}</span>
                </Col>
                <Col span={8}>
                  楼盘名称: <span className={styles.show_title}> {orderInfo?.buildingName}</span>
                </Col>
                <Col span={8}>
                  设计师:
                  <span className={styles.show_title}> {quoteBudgetInfo?.createdByName}</span>
                </Col>
              </Row>
              <Row style={{ marginBottom: '16px' }}>
                <Col span={8}>
                  客户电话: <span className={styles.show_title}> {orderInfo?.customerPhone}</span>
                </Col>
                <Col span={8}>
                  基本信息:{' '}
                  <span className={styles.show_title}>
                    {' '}
                    {`${argObj?.toiletNum}卫${argObj?.roomNum}卧 丨 ${argObj?.area}㎡`}
                  </span>
                </Col>
                <Col span={8}>
                  空间规格:{' '}
                  <span className={styles.show_title}>
                    {' '}
                    {quoteBudgetInfo?.spaceQuoteBudgetItemList
                      ?.filter(item => item.spaceSpecParamValueId)
                      ?.map(item => {
                        let text = `${item?.showName}：${item?.spaceSpecParamValueName}  `
                        return text
                      })}
                  </span>
                </Col>
              </Row>
            </div>
          </div>
          <div className={styles.tabContentBox}>
            <Tabs items={tabsList} activeKey={activeKey} onChange={onChange} />
          </div>
          <div className={styles.baseContentBox}>
            {activeKey === 'CHOOSE' && (
              <div className={styles.left_tree_box}>
                <div className={styles.chooseMaterialBox_left_title}>
                  <p className={styles.title}>
                    空间({spaceOneArray?.filter(item => !item?.children?.length)?.length})
                  </p>
                </div>
                <Tree
                  className="draggable-tree"
                  // draggable
                  blockNode
                  // onDragEnter={onDragEnter}
                  // onDrop={onDrop}
                  treeData={spaceList}
                  selectedKeys={selectedKeys}
                  onExpand={onExpand}
                  expandedKeys={expandedKeys}
                  autoExpandParent={autoExpandParent}
                  onSelect={onSelect}
                  titleRender={titleRender}
                  // switcherIcon={switcherIconRender}
                  // showIcon={false}
                />
                {spaceList.length === 0 && (
                  <div className={styles.emptyBox}>
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      style={{
                        height: '100%',
                        margin: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                      }}
                    />
                  </div>
                )}
              </div>
            )}
            <div className={styles.chooseMaterialBox_right}>
              <div
                className={styles.table_box}
                style={{
                  marginTop: activeKey === 'CHOOSE' ? '0' : '16px',
                  marginBottom: activeKey === 'CHOOSE' ? '20px' : '0',
                }}
              >
                {activeKey === 'CHOOSE' ? (
                  spaceOneArray?.length > 0 &&
                  spaceOneArray?.map((item, index) => {
                    if (!item?.children?.length) {
                      return (
                        <div>
                          <div
                            className={styles.chooseMaterialBox_right_title}
                            id={`spaceId_${item?.id}`}
                          >
                            <div className={styles.right_title_left}>{item.title}</div>
                          </div>
                          <Table
                            rowKey="key"
                            dataSource={tableData[item?.id]}
                            columns={columns}
                            pagination={false}
                            scroll={{
                              x: '900px',
                              y: tableData[item?.id]?.length ? '500px' : undefined,
                            }}

                            // loading={loading}x
                            // ref={tableRef}
                          ></Table>
                        </div>
                      )
                    }
                  })
                ) : (
                  <Table
                    rowKey="key"
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    // loading={loading}
                    scroll={{ x: '900px', y: dataSource?.length ? '500px' : undefined }}
                    ref={tableRef}
                  ></Table>
                )}
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </SBack>
  )
}
